import { requiredUuidString } from '../zod-helpers/index.js';
import { bomItemGroupMemberSchema, isRawGoodGroupMember, RAW_GOOD_ONLY_GROUP_MEMBER_MESSAGE, } from './item-group-member.js';
export const addBomItemGroupMemberInputSchema = bomItemGroupMemberSchema
    .extend({
    bomItemGroupId: requiredUuidString('Option group is required.', 'Invalid group selection.'),
})
    .refine(isRawGoodGroupMember, {
    message: RAW_GOOD_ONLY_GROUP_MEMBER_MESSAGE,
    path: ['typeId'],
});
//# sourceMappingURL=add-item-group-member-input.js.map